import { WithSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#negation-pseudo}
 */
export class Not extends WithSelector {
    static of(selector) {
        return new Not(selector);
    }
    constructor(selector) {
        super("not", selector, selector.specificity);
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context) {
        return !this._selector.matches(element, context);
    }
    equals(value) {
        return value instanceof Not && value._selector.equals(this._selector);
    }
    toJSON() {
        return {
            ...super.toJSON(),
        };
    }
}
(function (Not) {
    Not.parse = (parseSelector) => WithSelector.parseWithSelector("not", parseSelector, Not.of);
})(Not || (Not = {}));
//# sourceMappingURL=not.js.map